<template>
  <div class="inner-scroll" :class="{ 'has-footer': hasFooter }">
    <div class="content flow-items-modal-scroll">
      <div class="tab tab-form">
        <div ref="formContainer" class="form-container">
          <form
            class="codelos-app"
            ref="customdbFrom"
            id="form"
            :class="{ 'full-width': isFullWidth }"
            @submit.prevent="validateInputs"
          >
            <div
              v-for="(tab, tabIdx) in mutableStructure.tabs"
              :key="tab.id"
              class="form-tab"
              ref="formBuilderElementWraper"
            >
              <div v-for="(row, rowIdx) in tab.rows" :key="rowIdx" class="row">
                <div
                  v-for="(col, colIdx) in row.cols"
                  :key="colIdx"
                  class="col"
                  :class="{
                    showResultInForm:
                      colIdx !== 0 && colIdx === row.cols.length - 1,
                  }"
                >
                  <template
                    v-if="!(colIdx !== 0 && colIdx === row.cols.length - 1)"
                  >
                    <div
                      v-for="(element, idx) in filteredMutableElements"
                      v-show="showElements(element.type)"
                      :key="idx"
                      :id="idx"
                      :class="{
                        large: isLargeWrapperRequired(element.type),
                      }"
                    >
                      <ElementRenderer
                        class="form-elements"
                        :ref="`formElements${element.id}`"
                        :element="element"
                        :colIdx="colIdx"
                        :tabIdx="tabIdx"
                        :rowIdx="rowIdx"
                        :idx="idx"
                        :elementCount="mutableElements.length"
                        :isLargeWrapperRequired="isLargeWrapperRequired"
                        :isUserHasAccess="isUserHasAccess"
                        :isEditable="isEditable"
                        :activeDropZone="activeDropZone"
                        :isContentEditable="isContentEditable"
                        :isEmptyFileInput="isEmptyFileInput"
                        :isFullWidth="isFullWidth"
                        :selectedDatabase="selectedDatabase"
                        :isAddOnly="isAddOnly"
                        @onFileSelected="onFileSelected"
                        @onFileDelete="onFileDelete"
                        :isAddingNewItem="isAddingNewItem"
                        :draggedElementIdx="draggedElementIdx"
                        @editElement="editElement"
                        @dragover="dragover"
                        @drop="drop"
                        @drag="drag"
                        @removeElement="removeElement"
                        @duplicateElement="duplicateElement"
                        @toggleErrorInForm="toggleErrorInForm"
                      />
                    </div>
                  </template>
                </div>
                <div
                  class="drop-zone vertical"
                  v-if="false"
                  :id="rowIdx"
                  @dragover="dragover"
                  @drop="drop"
                ></div>
              </div>
            </div>
            <input
              v-show="false"
              type="submit"
              value="Submit"
              ref="submitBtn"
            />
          </form>
          <div ref="addButton" class="add-button-wrapper" v-if="isEditable">
            <div class="add-button" @click.stop="toggleAddDropDown()">+</div>
            <div
              ref="dropDown"
              class="drop-down add-element"
              :style="{
                top: `${dropDownTop}px`,
                visibility: isAddElementVisible ? 'visible' : 'hidden',
              }"
            >
              <div
                v-for="(type, idx) in selectableTypes"
                :key="idx"
                class="item"
                @click="addElement(type.element, type.name)"
                v-click-outside="closeAddDropDown"
                :class="{
                  'item-disabled': isElementDisabled(type.element, type.name),
                }"
              >
                <img :src="getImgUrl(type.icon)" alt="" />
                {{ type.caption }}
              </div>
            </div>
          </div>
        </div>
        <elementProps
          v-if="isPropsModalVisible"
          ref="propsModal"
          :isCreateCustomDB="isCreateCustomDB"
          :element="this.selectedElement"
          :existingNames="existingNames"
          :reservedElementKeys="reservedElementKeys"
          :isUserHasAccess="isUserHasAccess"
          :selectedDatabase="selectedDatabase"
          @close="togglePropsModal"
          @changeElement="changeElement"
          @writeMessage="writeMessage"
          @onFileSelected="onFileSelected"
          @onFileDelete="onFileDelete"
          @onSheetFileSelect="$emit('onSheetFileSelect', $event)"
        ></elementProps>
      </div>
    </div>
    <LoadingSpinner v-show="loading" :loadingCaption="'wird gespeichert...'" />
  </div>
</template>

<script>
import LoadingSpinner from '../../components/widgets/LoadingSpinner.vue';
import ElementRenderer from './FormBuilderElementComponent.vue';
import { getWizardData } from '../../utils/helpers';
import { askChatGPT } from '../../services/workflow.service';
export default {
  name: 'Form-Builder',
  data() {
    return {
      reservedElementKeys: ['id', 'created', 'updated', 'owner'],
      selectedElement: null,
      isPropsModalVisible: false,
      activeDropZone: null,
      loading: false,
      isAddElementVisible: false,
      typeList: [
        {
          name: 'text',
          caption: 'Text',
          icon: './text.svg',
          visibility: 'everyone',
          element: {
            name: 'text',
            label: 'Text ',
            placeholder: 'Text',
            type: 'text',
            value: 'Das ist ein Beispieltext',
            layoutItem: false,
          },
        },
        {
          name: 'number',
          caption: 'Zahl',
          icon: './number.svg',
          visibility: 'everyone',
          element: {
            name: 'zahl',
            label: 'Zahl ',
            placeholder: '1',
            type: 'number',
            value: 1,
            layoutItem: false,
          },
        },
        {
          name: 'formated number',
          caption: 'formatierte Zahl',
          icon: './number.svg',
          visibility: 'everyone',
          element: {
            name: 'formatiertezahl',
            label: 'formatierte Zahl ',
            placeholder: '1',
            type: 'formatted_number',
            value: 1,
            layoutItem: false,
          },
        },
        {
          name: 'email',
          caption: 'E-Mail-Adresse',
          icon: './mail.svg',
          visibility: 'everyone',
          element: {
            name: 'email',
            label: 'Email ',
            placeholder: 'Email',
            type: 'email',
            value: 'info@codelos.io',
            layoutItem: false,
          },
        },
        {
          name: 'file',
          caption: 'Datei',
          icon: './file.svg',
          visibility: 'everyone',
          element: {
            name: 'file',
            label: 'File ',
            type: 'file',
            value: '',
            layoutItem: false,
          },
        },
        {
          name: 'file',
          caption: 'Datei New',
          icon: './file.svg',
          visibility: 'everyone',
          element: {
            name: 'filenew',
            label: 'file new',
            type: 'filenew',
            value: null,
            layoutItem: false,
          },
        },
        {
          name: 'image',
          caption: 'Bild',
          icon: './image-icon.svg',
          visibility: 'everyone',
          element: {
            name: 'image',
            label: 'Bild ',
            type: 'image',
            value: '',
            layoutItem: true,
            url: '',
          },
        },
        {
          name: 'video',
          caption: 'Video',
          icon: './video-icon.svg',
          visibility: 'everyone',
          element: {
            name: 'video',
            label: 'Video ',
            type: 'video',
            value: '',
            layoutItem: true,
            url: '',
          },
        },
        {
          name: 'radio',
          caption: 'Optionsfeld',
          icon: './options.svg',
          visibility: 'everyone',
          element: {
            name: 'option',
            label: 'Option ',
            type: 'radio',
            value: 'option 1',
            options: [
              { label: 'option 1', checked: true },
              { label: 'option 2', checked: false },
            ],
            layoutItem: false,
          },
        },
        {
          name: 'radiooval',
          caption: 'Optionskasten',
          icon: './radiocard.svg',
          visibility: 'everyone',
          element: {
            name: 'radiooval',
            label: 'Optionskasten  ',
            type: 'radio',
            value: 'option 1',
            options: [
              { label: 'option 1', checked: true },
              { label: 'option 2', checked: false },
            ],
            attributes: {
              required: true,
              disabled: false,
              appearance: 'oval',
              'v-model': 'picked',
            },
            layoutItem: false,
          },
        },
        {
          name: 'radiocard',
          caption: 'Optionskarten',
          icon: './checkboxcard.svg',
          visibility: 'everyone',
          element: {
            name: 'radiocard',
            label: 'Optionskarten  ',
            type: 'radio',
            value: 'option 1',
            options: [
              { label: 'option 1', img: '', checked: true },
              { label: 'option 2', img: '', checked: false },
            ],
            attributes: {
              required: true,
              disabled: false,
              appearance: 'card',
              'v-model': 'picked',
              isImgShowInBackGround: false,
              isShowTitleAndDescription: false,
            },
            layoutItem: false,
          },
        },
        {
          name: 'checkbox',
          caption: 'Kontrollkästchen',
          icon: './checkbox.svg',
          visibility: 'everyone',
          element: {
            name: 'kontrollk',
            label: 'Kontrollkästchen ',
            type: 'checkbox',
            value: [],
            options: [
              { label: 'option 1', checked: false },
              { label: 'option 2', checked: false },
            ],
            layoutItem: false,
          },
        },
        {
          name: 'checkboxoval',
          caption: 'Kontrollkasten',
          icon: './radiocard.svg',
          visibility: 'everyone',
          element: {
            name: 'checkboxoval',
            label: 'Kontrollkasten  ',
            type: 'checkbox',
            value: [],
            options: [
              { label: 'option 1', checked: false },
              { label: 'option 2', checked: false },
            ],
            attributes: {
              required: true,
              disabled: false,
              appearance: 'oval',
              'v-model': 'checked',
            },
            layoutItem: false,
          },
        },
        {
          name: 'checkboxcard',
          caption: 'Kontrollkarten',
          icon: './checkboxcard.svg',
          visibility: 'everyone',
          element: {
            name: 'checkboxcard',
            label: 'Kontrollkarten  ',
            type: 'checkbox',
            value: [],
            options: [
              { label: 'option 1', img: '', checked: false },
              { label: 'option 2', img: '', checked: false },
            ],
            attributes: {
              required: true,
              disabled: false,
              appearance: 'card',
              'v-model': 'checked',
              isImgShowInBackGround: false,
              isShowTitleAndDescription: false,
            },
            layoutItem: false,
          },
        },
        {
          name: 'select',
          caption: 'Dropdown-Menü',
          icon: './dropdown-icon.svg',
          visibility: 'hidden',
          element: {
            name: 'dropdownmenu',
            label: 'Dropdown-Menü  ',
            type: 'select',
            value: '',
            options: [
              { label: 'Auswahl 1', value: 'Wert 1' },
              { label: 'Auswahl 2', value: 'Wert 2' },
            ],
            attributes: {
              required: true,
              disabled: false,
              appearance: 'oval',
              'v-model': 'picked',
            },
          },
        },
        {
          name: 'date',
          caption: 'Datum',
          icon: './date.svg',
          visibility: 'everyone',
          element: {
            name: 'datum',
            label: 'Datum ',
            placeholder: 'Datum',
            type: 'date',
            value: '2025-01-01',
            layoutItem: false,
          },
        },
        {
          name: 'datetime-local',
          caption: 'Datum & Uhrzeit',
          icon: './datetime.svg',
          visibility: 'everyone',
          element: {
            name: 'datumuhrzeit',
            label: 'Datum & Uhrzeit ',
            placeholder: 'Datum & Uhrzeit',
            type: 'datetime-local',
            value: '2025-01-01T01:00',
            layoutItem: false,
          },
        },
        {
          name: 'textarea',
          caption: 'Textbereich',
          icon: './textarea.svg',
          visibility: 'everyone',
          element: {
            name: 'textfeld',
            label: 'Textfeld ',
            placeholder: 'Textfeld',
            type: 'textarea',
            value: 'Das ist ein Beispieltext in einem Textfeld.',
            layoutItem: false,
          },
        },
        {
          name: 'objectlist',
          caption: 'Liste',
          icon: './list.svg',
          visibility: 'everyone',
          element: {
            name: 'objectlist',
            label: 'Liste  ',
            type: 'objectlist',
            value: [],
            schema: [],
            layoutItem: false,
          },
        },
        {
          name: 'smartmessage',
          caption: 'Smart message',
          icon: './ai-icon.svg',
          visibility: 'everyone',
          element: {
            name: 'smartmessage',
            label: 'Smart Message  ',
            placeholder: 'Textfeld',
            type: 'smartmessage',
            value: 'kannst du mir eine Zusammenfassung über die Daten machen?',
            layoutItem: false,
          },
        },
        {
          name: 'range',
          caption: 'Schieberegler',
          icon: './range-icon.svg',
          visibility: 'everyone',
          element: {
            name: 'schieberegler',
            label: 'Schieberegler  ',
            placeholder: '',
            type: 'range',
            value: 15,
            attributes: {
              min: 1,
              max: 100,
            },
            layoutItem: false,
          },
        },
        {
          name: 'barcode',
          caption: 'Barcode',
          icon: './mail.svg',
          visibility: 'hidden',
          layoutItem: false,
        },
        {
          name: 'qrcode',
          caption: 'QR-Code',
          icon: './mail.svg',
          visibility: 'hidden',
          layoutItem: false,
        },
        {
          name: 'foto',
          caption: 'Foto',
          icon: './mail.svg',
          visibility: 'hidden',
          layoutItem: false,
        },
        {
          name: 'location',
          caption: 'Standort',
          icon: './mail.svg',
          visibility: 'hidden',
          layoutItem: false,
        },
        {
          name: 'html',
          caption: 'html',
          icon: './html.svg',
          visibility: 'admin',
          element: {
            name: 'html',
            label: 'HTML ',
            placeholder: 'HTML',
            type: 'html',
            value: '<div>Beispieldiv</div>',
            layoutItem: true,
          },
        },
        {
          name: 'hidden',
          caption: 'hidden',
          icon: './hidden.svg',
          visibility: 'everyone',
          element: {
            name: 'hidden',
            label: 'hidden ',
            placeholder: 'hidden',
            type: 'hidden',
            value: 'Verstecktes Feld',
            layoutItem: false,
          },
        },
        {
          name: 'model',
          caption: 'model',
          icon: './database-model.svg',
          visibility: 'admin',
          element: {
            name: 'model',
            label: 'Model ',
            placeholder: 'Model',
            type: 'model',
            value: 'model-id',
            layoutItem: false,
          },
        },
        {
          name: 'databaseid',
          caption: 'Database id',
          icon: './database-model.svg',
          visibility: 'admin',
          element: {
            name: 'databaseid',
            label: 'Database id ',
            placeholder: 'Database id',
            type: 'databaseid',
            value: 'database-id',
            layoutItem: false,
          },
        },
        {
          name: 'title',
          caption: 'Titel',
          icon: './title.svg',
          visibility: 'everyone',
          element: {
            name: 'title',
            label: 'Titel  ',
            placeholder: '',
            type: 'title',
            value: '',
            layoutItem: true,
          },
        },
        {
          name: 'description',
          caption: 'Beschreibungstext',
          icon: './description.svg',
          visibility: 'everyone',
          element: {
            name: 'description',
            label: 'Beschreibungstext  ',
            placeholder: '',
            type: 'description',
            value: '',
            layoutItem: true,
          },
        },
        {
          name: 'horizontalrule',
          caption: 'Trennlinie',
          icon: './line.svg',
          visibility: 'everyone',
          element: {
            name: 'horizontalrule',
            label: 'Trennlinie  ',
            placeholder: '',
            type: 'horizontalrule',
            value: '',
            layoutItem: true,
          },
        },
        {
          name: 'toggleliststart',
          caption: 'Klappliste',
          icon: './toggle.svg',
          visibility: 'everyone',
          element: {
            name: 'toggleliststart',
            label: 'Klappliste-Start  ',
            type: 'togglelist',
            value:
              "<label class='collapsible-{increment}'>{label}</label>\n<div class='content'>\n",
            layoutItem: true,
          },
        },
        {
          name: 'wrapperstart',
          caption: 'Wrapper',
          icon: './toggle.svg',
          visibility: 'everyone',
          element: {
            name: 'wrapper-{increment}-start',
            label: 'Wrapper-Start  ',
            type: 'wrapper',
            value: '',
            layoutItem: true,
          },
        },
        {
          name: 'sheet',
          caption: 'Blatt',
          icon: './file.svg',
          visibility: 'everyone',
          isInternalUseOnly: true,
          element: {
            name: 'sheet',
            label: 'sheet',
            type: 'sheet',
            value: null,
            layoutItem: false,
          },
        },
        {
          name: 'wizard',
          caption: 'wizard',
          icon: './wizard.svg',
          visibility: 'everyone',
          element: {
            name: 'wizardtab',
            label: 'tab  ',
            placeholder: '',
            type: 'title',
            value: '',
            layoutItem: true,
            defaultTabs: 4,
          },
        },
        {
          name: 'link-to-database',
          caption: 'Link-zur-Datenbank',
          icon: './link-to-db.svg',
          visibility: 'everyone',
          element: {
            name: 'link',
            label: 'link',
            placeholder: '',
            value: null,
            layoutItem: false,
            type: 'linktodb',
            selectedDatabaseCaption: null,
            selectedDatabaseID: null,
            selectedDatabaseType: null,
          },
        },
      ],
      mutableElements: null,
      mutableStructure: null,
      selectedElementID: null,
      dropDownTop: 200,
      draggedElementIdx: null,
      isErrorInForm: false,
    };
  },
  props: {
    elements: Array,
    structure: {
      type: Object,
      default: () => ({
        tabs: [{ id: 0, rows: [{ id: 0, cols: [{ id: 0 }] }] }],
      }),
    },
    isFullWidth: Boolean,
    isEditable: Boolean,
    isContentEditable: Boolean,
    elsToShow: Array,
    isCreateCustomDB: Boolean,
    isUserHasAccess: { type: Boolean, default: true },
    isAddingNewItem: {
      type: Boolean,
      default: false,
    },
    selectedDatabase: {
      type: Object,
      default: () => null,
    },
    isAddOnly: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
    databaseMeta: {
      type: Object,
    },
    hasFooter: { type: Boolean, default: false },
    elementsToHide: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  methods: {
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    isElementDisabled(ele, name) {
      if (name === 'wizard') {
        return this.elements.some((el) => el.defaultTabs);
      }

      return false;
    },
    showElements(type) {
      const restrictedTypes = ['html', 'model', 'databaseid'];
      return !restrictedTypes.includes(type) || this.isAdmin;
    },
    close() {
      this.$emit('close');
    },
    drag(id) {
      this.draggedElementIdx = id;
    },
    dragover(event, id) {
      this.activeDropZone = id.toString();
      event.preventDefault();
    },

    drop(event, targetIdx) {
      if (this.isEditable) {
        // Get relevant data from event
        const dropZone = event.target.classList[1];

        const selectedItem = this.mutableElements[this.draggedElementIdx];
        // Handle new cols
        if (dropZone == 'vertical') {
          let tab = this.activeTab;
          let row = targetIdx;
          let path = this.mutableStructure['tabs'][tab]['rows'][row]['cols'];

          // Update the draged item
          selectedItem.structure.col = path.length;

          // Create new col
          this.$set(path, path.length, { id: path.length });
        } else if (
          this.draggedElementIdx != null &&
          this.activeDropZone != null
        ) {
          const selected = this.mutableElements.splice(
            this.draggedElementIdx,
            1
          )[0];
          this.mutableElements.splice(this.activeDropZone, 0, selected);
        }

        this.activeDropZone = null;
        this.draggedElementIdx = null;
      }
    },
    togglePropsModal() {
      this.isPropsModalVisible = !this.isPropsModalVisible;
    },
    addSingleElement(elementDefaults) {
      if (
        elementDefaults.type === 'image' ||
        elementDefaults.type === 'video'
      ) {
        this.isPropsModalVisible = true;
      }
      var elementBase = {
        id: this.newID(),
        default: false,
        highlight: false,
        options: [],
        structure: {
          tab: 0,
          row: 0,
          col: 0,
        },
        attributes: {
          required: true,
          disabled: false,
        },
      };

      // Create deepcopies of both elements
      let elBase = JSON.parse(JSON.stringify(elementBase));
      let elDefaults = JSON.parse(JSON.stringify(elementDefaults));

      // Merge base & predefined values
      let e = { ...elBase, ...elDefaults };

      // Add tabindex to all non-layout items
      // TODO: Remove attr from Base and add baseAttr only when not layoutItem
      if (!elementDefaults.layoutItem) e.attributes.tabindex = '';

      // Create copy of final element
      let el = JSON.parse(JSON.stringify(e));

      // Add unique number to el.name
      let incNum = this.getIncrementNum(el.type);
      if (el.type == 'wrapper') {
        el.name = el.name.replaceAll('{increment}', incNum);
      } else {
        el.name += incNum;
      }
      el.label += incNum;

      // Handle togglelist-start
      if (el.type == 'togglelist')
        el.value = el.value.replaceAll('{increment}', incNum);

      // Push new element to flow
      this.mutableElements.push(el);
      this.selectedElement = el;

      // Handle togglelist-end
      if (el.type == 'togglelist') {
        const toggleEnd = this.getToggleListEnd(el, incNum);
        this.mutableElements.push(toggleEnd);
      }
      // Handle wrapper-end
      if (el.type == 'wrapper') {
        const wrapperEnd = this.getWrapperEnd(el);
        this.mutableElements.push(wrapperEnd);
      }
      this.$nextTick(function () {
        this.$refs.formBuilderElementWraper[0].scrollTop =
          this.$refs.formBuilderElementWraper[0].scrollHeight;
      });
    },
    addElement(elementDefaults, elementName) {
      if (!this.isElementDisabled(elementDefaults, elementName)) {
        if (elementName === 'wizard') {
          const defaultHtmlArray = getWizardData();

          for (
            let index = 0;
            index <= elementDefaults.defaultTabs - 1;
            index++
          ) {
            this.addSingleElement(elementDefaults);
          }

          for (
            let htmlIndex = 0;
            htmlIndex < defaultHtmlArray.length;
            htmlIndex++
          ) {
            this.addSingleElement(defaultHtmlArray[htmlIndex]);
          }
        } else {
          this.addSingleElement(elementDefaults);
        }

        // Hide dropdown
        this.toggleAddDropDown();
      }
    },
    getToggleListEnd(el, incNum) {
      // Create deepcopy
      let e = JSON.parse(JSON.stringify(el));

      // Turn start into end
      e.name = el.name.replace('start', 'end');
      e.label = el.label.replace('Start', 'Ende');
      // ATTENTION: / (slashs) in both <\/script> end tags must be delimited using \ after each format of the document
      e.value =
        // eslint-disable-next-line no-useless-escape
        '</div>\n<style>\n.collapsible-{increment}:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.content {\n  display: none;\n  overflow: hidden;\n}\n</style>\n<script>\nvar coll = document.getElementsByClassName("collapsible-{increment}");\nvar i;\n\nfor (i = 0; i < coll.length; i++) {\n  coll[i].addEventListener("click", function() {\n    this.classList.toggle("active");\n    var content = this.nextElementSibling;\n    if (content.style.display === "block") {\n      content.style.display = "none";\n    } else {\n      content.style.display = "block";\n    }\n  });\n}\n<\/script>';
      e.value = e.value.replaceAll('{increment}', incNum);
      return e;
    },
    getWrapperEnd(el) {
      // Create deepcopy
      let e = JSON.parse(JSON.stringify(el));

      // Turn start into end
      e.name = el.name.replace('start', 'end');
      e.label = el.label.replace('Start', 'Ende');

      return e;
    },
    removeElement(element) {
      var name = element.name;

      // If we remove selected element, unselect and close edit modal
      if (this.selectedElement && this.selectedElement.id == element.id) {
        this.isPropsModalVisible = false;
        this.selectedElement = null;
      }

      // For togglelist and div wrapper we always remove start & end
      if (!['togglelist', 'wrapper'].includes(element.type)) {
        this.mutableElements = this.mutableElements.filter((el) => {
          return el.name != name;
        });
      } else {
        this.mutableElements = this.mutableElements.filter((el) => {
          return el.id != element.id;
        });
      }
    },
    createUniqueName(name, num, idx) {
      if (!this.existingNames.includes(name)) {
        return name;
      } else {
        if (this.existingNames.includes(name)) {
          name = name.replace(/[0-9]*$/, '');
          name += num;
        }

        return this.createUniqueName(name, ++num, idx);
      }
    },
    createUniqueLabel(label, num, idx) {
      if (!this.existingLabels.includes(label)) {
        return label;
      } else {
        if (this.existingLabels.includes(label)) {
          label = label.replace(/[0-9]*$/, '');
          label += num;
        }

        return this.createUniqueLabel(label, ++num, idx);
      }
    },
    duplicateElement(e, idx) {
      let el = JSON.parse(JSON.stringify(e));
      // If last char is num replace
      const nameTailingNumbers = el.name.match(/\d+$/)
        ? parseInt(el.name.match(/\d+$/)[0])
        : 1;
      const labelTailingNumbers = el.label.match(/\d+$/)
        ? parseInt(el.label.match(/\d+$/)[0])
        : 1;

      // Add number and check element.name and element.label is unique
      el.name = this.createUniqueName(el.name, nameTailingNumbers + 1, idx);
      el.label = this.createUniqueLabel(el.label, labelTailingNumbers + 1, idx);

      this.mutableElements.splice(idx + 1, 0, el);
    },
    getImgUrl(img) {
      const images = require.context('../../assets/img/', false, /\.svg$/);

      return images(img);
    },
    getBuildUrl(img, type) {
      try {
        if (!type || ['custom', 'illustration'].includes(type)) return img;
        else if (type == 'icon') {
          const icons = require.context(
            '../../assets/img/icons/',
            false,
            /\.svg$/
          );
          return icons(img);
        } else return '';
      } catch (e) {
        return '';
      }
    },
    newID() {
      return Math.round(Math.random() * 100000 + new Date().getTime());
    },

    isEmptyFileInput(name) {
      let fileInputs = this.elements.filter(
        (e) => e.type == 'file' && e.files != '[object FileList]'
      );
      let fileInputNames = fileInputs.map((e) => e.label);
      return fileInputNames.includes(name);
    },
    getIncrementNum(type) {
      let currentNums = [];
      let typeArr = this.elements.filter((e) => e.type == type);

      if (typeArr.length > 0) {
        typeArr.forEach((e) => {
          let num = e.name.slice(-1);
          if (!isNaN(parseInt(num))) currentNums.push(num);
        });

        if (currentNums.length == 0) return 1;
        return Math.max(...currentNums) + 1;
      } else return 1;
    },
    toggleAddDropDown() {
      if (
        this.$refs.addButton.offsetTop - this.$refs.formContainer.offsetTop <=
        this.$refs.dropDown.clientHeight
      ) {
        this.dropDownTop = this.$refs.formContainer.offsetTop;
      } else {
        this.dropDownTop =
          this.$refs.formContainer.offsetTop +
          (this.$refs.addButton.offsetTop -
            this.$refs.formContainer.offsetTop -
            (this.$refs.dropDown.clientHeight - 100));
      }
      this.isAddElementVisible = !this.isAddElementVisible;
    },

    addMissingAttributes() {
      // Add structure to each element
      for (let el of this.mutableElements) {
        if (!el.hasOwnProperty('structure')) {
          el.structure = { tab: 0, row: 0, col: 0 };
        }
      }
    },
    validateInputs() {
      if (this.isErrorInForm) return false;
      if (this.isEditable) this.$emit('saveItem', this.mutableElements);
      else
        this.$emit(
          'saveItem',
          this.mutableElements.reduce((acc, cur) => {
            if (
              ['togglelist', 'wrapper'].includes(cur.type) &&
              cur.name.includes('start')
            ) {
              const elements = cur.elements;
              delete cur.elements;
              acc = [...acc, cur, ...elements];
            } else acc.push(cur);
            return acc;
          }, [])
        );
    },
    formSubmit() {
      if (!this.$refs.customdbFrom.checkValidity()) {
        const toggleId = this.$refs.customdbFrom
          .querySelectorAll(':invalid')[0]
          .closest('.content').id;

        if (
          toggleId &&
          !this.$refs[`formElements${toggleId}`][0].opennedTogglelist.includes(
            toggleId
          )
        )
          this.$refs[`formElements${toggleId}`][0].opennedTogglelist.push(
            toggleId
          );
      }
      setTimeout(() => {
        this.$refs.submitBtn.click();
      }, 50);
    },
    editElement(element) {
      let elNeedsValidation = this.isPropsModalVisible;
      // Toggle only if not visible
      if (!this.isPropsModalVisible) {
        this.isPropsModalVisible = true;
        this.$emit('toggleFlowReferenceModel', false);
        this.selectedElement = element;
      }

      // Add element without validation if first time
      if (!this.selectedElement) this.selectedElement = element;

      //To change element or To validate form
      if (elNeedsValidation) {
        this.$refs.propsModal.formSubmit(element);
      }
    },
    changeElement(e) {
      this.selectedElement = e;
    },
    isLargeWrapperRequired(type) {
      return ['textarea', 'html', 'smartmessage'].includes(type);
    },
    async writeMessage(element) {
      if (
        this.mutableElements.length === 1 &&
        this.mutableElements[0].type === 'smartmessage'
      ) {
        this.showToaster(
          'Bitte fügen Sie mindestens ein Element hinzu',
          'Fehlerhaft !',
          'danger'
        );
      } else {
        let question;
        if (
          element.value &&
          element.value !== null &&
          element.value.trim() !== ''
        ) {
          question = ` Frage: ${element.value} \n`;
        } else {
          question = ` Frage: kannst du mir eine Zusammenfassung über die Daten machen? \n `;
        }
        const objectArray = this.mutableElements.reduce((acc, cur) => {
          if (cur.id != element.id) {
            acc[cur.label] = cur.value;
          }
          return acc;
        }, {});
        const finalMessage =
          question + ` data : ` + JSON.stringify(objectArray);
        try {
          const res = await askChatGPT({
            prompt: finalMessage,
          });
          if (res.status != 200) throw new Error(res.statusText);
          const smartMessageIndex = this.mutableElements.findIndex(
            (ele) => ele.id === element.id
          );
          this.selectedElement = {
            ...element,
            value: res.data.message,
          };
          this.mutableElements.splice(
            smartMessageIndex,
            1,
            this.selectedElement
          );
        } catch (err) {
          throw new Error(err);
        }
      }
    },
    onFileSelected(file, element = null) {
      const fileObject = {
        link: null,
        type: file.name.split('.')[1],
        extention: file.type,
        name: file.name,
        size: file.size / 1000,
        created: file.lastModified,
        modified: file.lastModified,
        readOnly: true,
      };

      this.selectedElementID = this.selectedElement
        ? this.selectedElement.id
        : element.id;

      if (this.selectedElement && this.selectedElement.type === `filenew`) {
        this.$refs[
          `formElements${this.selectedElement.id}`
        ][0].onFileSelectedFromElementProps(fileObject);
      }
      this.mutableElements.forEach((mutableElement) => {
        if (mutableElement.type === 'togglelist' && mutableElement.elements) {
          mutableElement.elements.forEach((el) => {
            if (el.id === this.selectedElementID) {
              el.value = fileObject;
              el.files = file;
            }
          });
        } else if (mutableElement.id === this.selectedElementID) {
          mutableElement.value = fileObject;
          mutableElement.files = file;
        }
      });
    },
    onFileDelete(element = null) {
      this.selectedElementID = this.selectedElement
        ? this.selectedElement.id
        : element.id;
      if (this.$refs[`formElements${this.selectedElementID}`]) {
        this.$refs[`formElements${this.selectedElementID}`][0].onFileDelete(
          element,
          false
        );
      }
      this.mutableElements.forEach((mutableElement) => {
        if (mutableElement.type === 'togglelist' && mutableElement.elements) {
          mutableElement.elements.forEach((el) => {
            if (el.id === this.selectedElementID) {
              el.value = null;
              el.files = null;
            }
          });
        } else if (mutableElement.id === this.selectedElementID) {
          mutableElement.value = null;
          mutableElement.files = null;
        }
      });
    },
    closeAddDropDown() {
      this.isAddElementVisible = false;
    },
    isKeyNotInElementObject(element, key) {
      (element.type === 'radio' || element.type === 'checkbox') &&
        element.attributes.appearance === 'card' &&
        !(key in element.attributes);
    },
    toggleErrorInForm(newValue) {
      this.isErrorInForm = newValue;
    },
  },
  created() {
    // Add class to make background fixed
    document.body.classList.add('modal-open');

    if (this.isEditable) {
      this.elements.forEach((element) => {
        if (this.isKeyNotInElementObject(element, 'isImgShowInBackGround')) {
          element.attributes['isImgShowInBackGround'] = false;
        }
        if (
          this.isKeyNotInElementObject(element, 'isShowTitleAndDescription')
        ) {
          element.attributes['isShowTitleAndDescription'] = false;
        }
      });
      this.mutableElements = JSON.parse(JSON.stringify(this.elements));
    } else {
      let isNestedStart = false;
      this.mutableElements = JSON.parse(JSON.stringify(this.elements)).reduce(
        (acc, cur) => {
          if (
            ['togglelist', 'wrapper'].includes(cur.type) &&
            cur.name.includes('start')
          ) {
            isNestedStart = true;
            acc.push({ ...cur, elements: [] });
          } else if (isNestedStart) {
            acc[acc.length - 1].elements.push(cur);
            if (
              ['togglelist', 'wrapper'].includes(cur.type) &&
              cur.name.includes('end')
            )
              isNestedStart = false;
          } else {
            acc.push(cur);
          }
          return acc;
        },
        []
      );
    }
    this.mutableStructure = JSON.parse(JSON.stringify(this.structure));
    this.addMissingAttributes();
  },
  destroyed() {
    // remove class that makes background fixed
    document.body.classList.remove('modal-open');
  },
  watch: {
    mutableElements() {
      this.$emit('saveElements', this.mutableElements);
    },
    mutableStructure() {
      this.$emit('saveStructure', this.mutableStructure);
    },
  },
  computed: {
    getMutableElements() {
      if (this.databaseMeta && this.databaseMeta.sql_cdls) {
        const sqlCdls = JSON.parse(this.databaseMeta.sql_cdls);

        return this.mutableElements.filter(
          (element) =>
            !Object.values(sqlCdls).find((key) => key === element.name)
        );
      } else return this.mutableElements;
    },
    filteredMutableElements() {
      if (this.search) {
        return JSON.parse(JSON.stringify(this.getMutableElements)).reduce(
          (acc, cur) => {
            if (cur.label.toLowerCase().includes(this.search.toLowerCase())) {
              if (
                cur.type == 'togglelist' &&
                cur.name.includes('start') &&
                cur.elements?.length
              ) {
                cur.elements = cur.elements.filter((element) =>
                  element.label
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
                );
              }
              acc.push(cur);
            }
            return acc;
          },
          []
        );
      } else {
        return this.getMutableElements;
      }
    },
    existingNames() {
      let names = this.elements.map((e) => e.name);
      return names;
    },
    existingLabels() {
      return this.elements.map((e) => e.label);
    },
    user() {
      return this.$store.state.user;
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    paramString() {
      let paramString = '';

      this.elements.forEach((e) => {
        if (e.type != 'html') paramString += e.name + '=' + e.value + '&';
      });
      return paramString.slice(0, -1);
    },
    selectableTypes() {
      let tempTypeList;
      if (this.elementsToHide && this.elementsToHide.length > 0) {
        tempTypeList = [...this.typeList].filter(
          (el) => !this.elementsToHide.includes(el.name.trim())
        );
      } else {
        tempTypeList = this.typeList;
      }
      tempTypeList = tempTypeList.filter((el) => !el.isInternalUseOnly);
      if (!this.isUserHasAccess)
        tempTypeList = tempTypeList.filter((e) =>
          e.element ? e.element.layoutItem : e.layoutItem
        );
      if (this.elsToShow)
        return tempTypeList.filter((e) => this.elsToShow.includes(e.name));
      if (this.isAdmin)
        return tempTypeList.filter((e) => e.visibility != 'hidden');
      return tempTypeList.filter(
        (e) => e.visibility != 'hidden' && e.visibility != 'admin'
      );
    },
    activeTab() {
      return 0;
    },
  },
  components: {
    elementProps: () => import('../modals/elementProps.vue'),
    LoadingSpinner,
    ElementRenderer,
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind(el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  position: fixed;
  background: #ffffff;
  height: 98%;
  border-radius: 4px;
  display: block;
  width: 70%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 0;
  left: 15%;
  top: 1%;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

h1 {
  padding-top: 46px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 4px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.tab {
  text-align: left;
  background: #f9f9fb;
  padding: 20px 16px;
  padding-top: 0px;
}

.tab.tab-form {
  background-color: #fff;
}

.tab.tab-time {
  height: 350px;
}

.date {
  margin-top: 0;
  width: 53%;
}

.time {
  width: 33%;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  display: inline-block;
  width: 100%;
}

.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.input-group > button {
  min-width: 0;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  float: right;
  height: 50px;
  overflow: hidden;
}

button.pull-right {
  margin-right: 0px;
}

.btn-close.pull-right {
  margin-right: 15px;
  margin-top: 15px;
  height: 10px;
}
.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .form {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -893px -1110px;
}

.tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.icon {
  width: 30px;
  float: left;
  margin-right: 10px;
  margin-top: 6px;
}

.icon svg {
  fill: #959ba8;
}

.btn-default {
  background-color: #fff;
  color: #959ba8;
  text-align: center;
  border-color: rgb(214, 214, 221);
  line-height: 50px;
  cursor: pointer;
}

.tab.tab-form button {
  width: fit-content;
  padding-right: 19px;
  float: right;
  margin: 0 0 0 5px;
}

.tab.tab-form button.btn-green {
  padding-left: 20px;
}

.params {
  float: left;
  width: 30%;
}

.params > h2 {
  padding-top: 0;
  padding-bottom: 15px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #797c81;
  font-weight: 400;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 16px;
  text-transform: uppercase;
  text-align: left;
}

.modal.task .header {
  width: 100%;
}

.modal.task .header .tools {
  float: right;
  height: 70px;
  width: auto;
  flex-direction: row;
  margin-top: 5px;
}

.modal.task .header .tools .item {
  display: inline-block;
  text-align: center;
  line-height: 61px;
  margin-left: 10px;
}

.form-container {
  background: #fff;
  width: 100%;
}

.form-header {
  display: block;
  height: 100px;
}

.form-settings {
  float: right;
  padding-right: 25px;
}

.form-settings i {
  font-size: 30px;
  padding-left: 15px;
  cursor: pointer;
}

.form-container input.title {
  z-index: 4;
  text-align: center;
  display: block;
  padding-bottom: 8px;
  font-size: 33px;
  color: #464d5d;
  margin: 5px 5px 5px 7px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  border: 0;
  height: 50px;
  float: left;
  width: 99%;
}

.form-container input.description {
  z-index: 4;
  text-align: center;
  border: 0;
  display: block;
  float: left;
  margin: 5px 5px 15px 7px;
  width: 99%;
  color: #888d9c;
}

.form-input {
  cursor: text;
}

.form-input.highlighted {
  background: #ff000024;
  padding: 5px;
}

.add-button-wrapper {
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
}

.add-button {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-color: #191f25;
  padding: 5px;
  border-radius: 50%;
  font-size: 40px;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  height: 60px;
  width: 60px;
}

.add-button:hover {
  transform: scale(1.1);
}

.modal.task .header .tools .item:hover {
  transform: scale(1.1) rotate(0);
}

.input-group > button {
  min-width: 0;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  background: #fff;
  margin-bottom: 0;
  margin-left: 0;
  border-radius: 0 3px 3px 0;
  margin-top: 0;
  font-size: 35px;
  font-weight: 200;
}

.input-group > select {
  margin-right: 0;
  border-radius: 0 3px 3px 0;
}

.form-container form.codelos-app {
  /* width: 800px; */
  width: 80%; /* For New form elements */
  text-align: left;
  min-height: 207px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.form-container form.codelos-app .form-tab .row {
  justify-content: center;
}
.form-container form.codelos-app.full-width {
  width: 100%;
}

form .form-group {
  width: 100%;
  min-height: 35px;
  height: fit-content;
  margin-top: 0px;
  position: relative;
}

.form-group.large {
  height: 160px;
}
.round-button {
  cursor: pointer;
  display: block;
  color: #1d1d1f;
  border-radius: 50%;
  background-color: white;
  height: 60px;
  width: 60px;
  text-align: center;
  line-height: 60px;
  font-weight: 100;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
  transition: transform 0.2s ease-in-out;
  font-size: 17px;
}

.footer {
  position: fixed;
  bottom: 21px;
}
.message {
  position: absolute;
  color: #54c08a;
  font-size: 16px;
  margin: 0;
  margin-top: 3px;
}

.loading {
  width: 100%;
  height: 100%;
  background-color: #ffff;
  position: relative;
  top: -100%;
  z-index: 3;
}

.loading.transparent {
  background-color: #9191912e;
}

.progress-icon-wrapper {
  top: 0;
  bottom: 67px;
  height: fit-content;
  width: fit-content;
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;
}

.progress-icon {
  width: 76px;
  height: 76px;
  margin-left: auto;
  top: 0;
  left: 0;
  margin-right: auto;
  margin-top: 28px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

.file-key-selector {
  position: absolute;
  top: 25%;
  left: 40%;
  background: white;
  z-index: 10;
  width: 200px;
  height: 300px;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.drop-down {
  font-size: 14px;
  color: #4a556a;
  font-family: sans-serif;
  -webkit-font-smoothing: unset;
  padding: 11px;
  border-radius: 9px;
  box-shadow: 0 2px 8px rgb(31 37 50 / 18%);
  position: absolute;
  z-index: 100;
  width: 260px;
  list-style: none;
  background-color: #fff;
  overflow: scroll;
  max-height: calc(100vh - 260px);
  border: none;
  left: 22%;
  right: 100%;
}

.start-form-builder .drop-down {
  max-height: calc(100vh - 285px);
  left: 32%;
}

.drop-down.add-element img {
  background-color: #fefbfb;
  vertical-align: middle;
  border-style: none;
  width: 78px;
  height: 78px;
  padding: 13px;
  margin: 4px;
  border-radius: 5px;
  border: 1px solid #d2d0d0;
}

.drop-down.add-element .item {
  padding: 5px;
  border-radius: 5px;
  width: 100%;
  cursor: pointer;
}

.drop-down.add-element .item:hover {
  background-color: #f1efef;
}

/* .col {
  max-width: 89%;
} */

.showResultInForm {
  background-color: #cccccc;
}

.workflow-model-scroll .modal.task,
.workflow-model-scroll .modal.task .form-container {
  overflow: unset !important;
}
.workflow-model-scroll .modal.task .form-tab {
  max-height: calc(100vh - 380px);
  overflow-y: auto;
  overflow-x: hidden;
}

.drop-down.add-element * {
  box-sizing: border-box;
}

.form-container .add-button-wrapper .add-element .item.item-disabled {
  background: #e3e3e3fc !important;
  color: #a3a3a3;
  cursor: not-allowed;
  opacity: 0.6;
}

.form-container .add-button-wrapper .add-element .item.item-disabled img {
  background: #e3e3e3fc !important;
  color: #a3a3a3;
}

::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}
</style>
